// extracted by mini-css-extract-plugin
module.exports = {"PlayerHeader":"PlayerHeader_PlayerHeader__Ja0cD","Button":"PlayerHeader_Button__1cBlw"};